function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.5 111c30.1 0 54.5-24.4 54.5-54.5S86.6 2 56.5 2 2 26.4 2 56.5 26.4 111 56.5 111z",
  fill: "url(#VoucherLogo_svg__paint0_linear)",
  stroke: "#fff",
  strokeWidth: 3
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "VoucherLogo_svg__paint0_linear",
  x1: 2,
  y1: 2,
  x2: 2,
  y2: 111,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#033939"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#0A2432"
})));

var SvgVoucherLogo = function SvgVoucherLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113 113",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEzIiBoZWlnaHQ9IjExMyIgdmlld0JveD0iMCAwIDExMyAxMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNTYuNSAxMTFDODYuNTk5NSAxMTEgMTExIDg2LjU5OTUgMTExIDU2LjVDMTExIDI2LjQwMDUgODYuNTk5NSAyIDU2LjUgMkMyNi40MDA1IDIgMiAyNi40MDA1IDIgNTYuNUMyIDg2LjU5OTUgMjYuNDAwNSAxMTEgNTYuNSAxMTFaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjIiIHkxPSIyIiB4Mj0iMiIgeTI9IjExMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDMzOTM5Ii8+CjxzdG9wIG9mZnNldD0iMC45OTg2MjgiIHN0b3AtY29sb3I9IiMwQTI0MzIiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgVoucherLogo as ReactComponent };